import ArrowRightSmallIconPath from "@ingka/ssr-icon/paths/arrow-right-small";

export default ArrowRightSmallIconPath;
